import React, { useEffect, useState } from "react";
import "./selectDonationAmount.css"
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { RenderAmount } from "../components/renderAmount";
import { RootState, useAppDispatch } from "../state/store";
import { DonationState, setDonationAmount } from "../state/donation";
import { Navigate, useNavigate } from "react-router-dom";
import { CheckoutState, resetCheckoutState } from "../state/checkout";
import { useSelector } from "react-redux";
import { AuthInfo, AuthState } from "../state/auth";
import { text } from "stream/consumers";
import { DonationHeader } from "./donationHeader";
import { DonationFooter } from "./donationFooter";
import { getDonationRows } from "./donationAmountConfig";



export function SelectDonationAmount() {

    const [selectedAmount, setSelectedAmount] = useState<number>(0);
    const appDispatch = useAppDispatch();
    const navigate = useNavigate();
    const donationInfo = useSelector<RootState, DonationState>(state => state.DonationInfo);
    const loginState = useSelector<RootState, AuthState>(state => state.AuthInfo);

    useEffect(() => {
        appDispatch(resetCheckoutState());
    }, []);

    const onDonationAmountSelected = (amount: number) => {
        setSelectedAmount(amount);
        appDispatch(setDonationAmount(amount));
        navigate("/pay");
        setTimeout(() => {

        }, 1000);
    }

    const onPayClicked = () => {
        appDispatch(setDonationAmount(selectedAmount));
        navigate("/pay");
    }

    const renderPayButton = () => {
        return selectedAmount > 0 ?
            (<Button variant="outlined" size="lg" onClick={onPayClicked} style={{ backgroundColor: "#ffffff", color: "#7F499D" }}>
                Pay <span style={{ fontWeight: "bold" }}>${selectedAmount}</span>  Using Card (Note: No Receipt will be issued)
            </Button>) :
            (<React.Fragment />);
    }

    const rows =  getDonationRows(loginState.authInfo?.username);

    const renderAmounts = () => {
        return (<>
            {rows.map(
                (eachRow, index) => {
                    return (
                        <Row key={index} style={{ marginTop: "10px" }}>
                            {eachRow.map(eachAmount =>
                            (
                                <Col key={eachAmount.amount} md={6} sm={12} lg={6}>
                                    <RenderAmount value={eachAmount.amount} text={eachAmount.text} onClicked={onDonationAmountSelected} selected={selectedAmount === eachAmount.amount} />
                                </Col>
                            ))}
                        </Row>)
                })}
        </>);
    };

    return (
        <div className="select-amount-container">
            <DonationHeader/>
            {renderAmounts()}
            <Row>
                <Col md={2} sm={2} lg={2}></Col>
                <Col md={8} sm={8} lg={8}>
                    <div className="d-grid gap-2" style={{ marginTop: '35px' }}>
                        {renderPayButton()}
                    </div>
                </Col>
                <Col md={2} sm={2} lg={2}></Col>
            </Row>
            <DonationFooter />
        </div>
    )
}